/**
 * Thẻ tài khoản admin — hồ sơ và form đặt lại mật khẩu.
 */
import { ButtonSpinner } from '../Common/ButtonSpinner';

export const AdminUserCard = ({
  adminUser,
  users,
  common,
  resetPassword,
  isResetting,
  onResetPasswordChange,
  onResetPassword,
}) => (
  <article className="admin-user-card">
    <div className="admin-user-card-header">
      <div className="admin-user-card-profile">
        {adminUser.avatar ? (
          <img className="admin-user-card-avatar" src={adminUser.avatar} alt="" loading="lazy" />
        ) : (
          <span className="admin-user-card-avatar admin-user-card-avatar--fallback" aria-hidden="true">
            {adminUser.name?.charAt(0)?.toUpperCase() || 'A'}
          </span>
        )}
        <div>
          <h2>{adminUser.name}</h2>
          <span className="admin-user-role-badge">{users.roleLabel}</span>
        </div>
      </div>
    </div>

    <div className="admin-user-card-meta">
      <a className="admin-user-meta-item" href={`mailto:${adminUser.email}`}>
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true">
          <path
            d="M4 7.5A2.5 2.5 0 016.5 5h11A2.5 2.5 0 0120 7.5v9A2.5 2.5 0 0117.5 19h-11A2.5 2.5 0 014 16.5v-9z"
            stroke="currentColor"
            strokeWidth="1.75"
          />
          <path d="M5 8l7 5 7-5" stroke="currentColor" strokeWidth="1.75" strokeLinejoin="round" />
        </svg>
        {adminUser.email}
      </a>
      <span className="admin-user-meta-item">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true">
          <path
            d="M8.5 4.5h7a2 2 0 012 2v11a2 2 0 01-2 2h-7a2 2 0 01-2-2v-11a2 2 0 012-2z"
            stroke="currentColor"
            strokeWidth="1.75"
          />
          <path d="M10 7h4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
        </svg>
        {adminUser.phone || common.noPhone}
      </span>
    </div>

    <div className="admin-user-reset">
      <div className="admin-user-reset-head">
        <strong>{users.resetPasswordColumn}</strong>
        <span>{users.resetPasswordHint}</span>
      </div>
      <div className="admin-user-reset-row">
        <input
          type="password"
          minLength="8"
          placeholder={users.newPasswordPlaceholder}
          value={resetPassword}
          onChange={(event) => onResetPasswordChange(event.target.value)}
        />
        <button
          className="admin-user-reset-button"
          type="button"
          disabled={isResetting}
          onClick={onResetPassword}
        >
          {isResetting && <ButtonSpinner />}
          {isResetting ? users.resetting : users.resetButton}
        </button>
      </div>
    </div>
  </article>
);
